import React from 'react';

type Props = {
  className?: string;
};

export const Skeleton: React.FC<Props> = ({ className = '' }) => {
  return (
    <div className={`animate-pulse rounded-md bg-gray-200 ${className}`} />
  );
};


